import {Injectable} from "@angular/core";
import {CompanyServiceA2} from "./company_a2.service";
import {GAService} from "../root/ga/ga.service";
import {CookieOptions, CookieService} from "ngx-cookie";
import {Subject} from "rxjs/Subject";
import {NewRelicService} from "./newrelic.service";

@Injectable()
export class SessionService {

    private readonly COMPANY_TO_REPRESENT = "companyToRepresent";
    private readonly HAS_COMPANY_SELECTED = "hasCompanySelected";

    private session: any;
    private visibleSidebar: boolean;
    private targetUrl: string;
    isDataLoaded: boolean;
    private userLogged: any;

    //TODO: Implementar REDUX para hacer este tipo de cosas de forma prolija y consistente
    subject:Subject<any> = new Subject();
    cleanCompanySubject: Subject<boolean> = new Subject();
    companyToRepresent: Subject<boolean> = new Subject();

    private options: CookieOptions = {
        path: '/cars-sara-v2/web'
    };

    constructor(private companyServiceA2: CompanyServiceA2, private _cookieService: CookieService,
                private gaService: GAService, private newRelicService: NewRelicService) {
        this.visibleSidebar = false;
        this.targetUrl = null;
        this.isDataLoaded = false;
    }

    isVisibleSidebar() {
        return this.visibleSidebar;
    }

    initializeUser(user) : Promise<void> {
        this.setUserInfo(user);
        let initializeUserPromise: Promise<void> = new Promise((resolve, reject) => {
            if (user.userType == "DESPEGAR") {
                let companyTo = this._cookieService.getObject(this.COMPANY_TO_REPRESENT);
                if (!!companyTo && this._cookieService.get(this.HAS_COMPANY_SELECTED)) {
                    this.setCompanyToRepresent(companyTo);
                }
                this.visibleSidebar = true;
                this.subject.next({done:true});
                resolve();

            } else {
                this.companyServiceA2.get(user.companyOid).subscribe((data) => {
                    this.setCompanyToRepresent(data);
                    this.visibleSidebar = true;
                    this.subject.next({done:true});
                    resolve();
                }, (error) => {
                    this.newRelicService.noticeError(new UserInitializationError("Error while getting company info.", error));
                    reject();
                });
            }
        });
        return initializeUserPromise;
    };

    private setUserInfo(user) {
        if (user == null) return;

        this.userLogged = user;
        var labelSize = 25;
        var userFullName = user.firstName + ' ' + user.lastName;
        var elipsis = userFullName.length > labelSize ? '...' : '';

        this.session = {
            username: user.username,
            firstName: user.firstName,
            lastName: user.lastName,
            userLabel: userFullName.substring(0, labelSize) + elipsis,
            userTitle: userFullName,
            userType: user.userType,
            authorities: user.authorities,
            encodedUserName: user.encodedUserName
        };

        this.gaService.setDimension('set', 'dimension1', this.session.userType);
        this.gaService.setDimension('set', 'dimension2', this.session.encodedUserName);

        // this.sidebarServiceA2.enableButtons(this);
    };

    setCompanyToRepresent(company) {
        this.session.companyOid = company.oid;
        this.session.companyName = company.companyName;
        this.session.currencyCode = company.currencyCode;
        this.session.moneda = company.currencyCode;
        this.session.countryOid = company.countryOid;
        this.session.countryCode = company.countryCode;

        this.setCompanyCustomDimensionForGoogleAnalytics(company);

        var companyToRepresent = {
            oid: company.oid,
            companyName: company.companyName,
            currencyCode: company.currencyCode,
            countryOid: company.countryOid,
            countryCode: company.countryCode
        };
        this.companyToRepresent.next(true);
        this._cookieService.remove(this.COMPANY_TO_REPRESENT, this.options);
        this._cookieService.putObject(this.COMPANY_TO_REPRESENT, companyToRepresent, this.options);
        this._cookieService.put(this.HAS_COMPANY_SELECTED, 'true', this.options);
    };

    cleanCompanyToRepresent() {
        if (this.session) {
            this.session.companyOid = undefined;
            this.session.companyName = undefined;
            this.session.currencyCode = undefined;
            this.session.moneda = undefined;
            this.session.countryCode = undefined;
        }
        this.cleanCompanyCustomDimensionForGoogleAnalytics();
        this._cookieService.putObject(this.COMPANY_TO_REPRESENT, {}, this.options);
        this._cookieService.put(this.HAS_COMPANY_SELECTED, 'false', this.options);
        this.cleanCompanySubject.next(true);
    };

    hasCompanyToRepresent() {
        return !(this.session) ? false : (this.session.companyOid != null);
    };

    private setCompanyCustomDimensionForGoogleAnalytics(company) {
        /*
         * provider-name (Nombre comercial): dimension3
         * provider-ID: dimension4
         * provider-country-code: dimension5
         * */
        this.gaService.setDimension('set', 'dimension3', company.tradeName);
        this.gaService.setDimension('set', 'dimension4', company.oid);
        this.gaService.setDimension('set', 'dimension5', company.countryCode);
    }

    private cleanCompanyCustomDimensionForGoogleAnalytics() {
        /*
         * provider-name (Nombre comercial): dimension3
         * provider-ID: dimension4
         * provider-country-code: dimension5
         * */
        this.gaService.setDimension('set', 'dimension3', null);
        this.gaService.setDimension('set', 'dimension4', null);
        this.gaService.setDimension('set', 'dimension5', null);
    }

    cleanSession() {
        this.visibleSidebar = false;
        this.cleanCompanyToRepresent();
        this.session = null;
        this.targetUrl = null;
    };

    loggedUserAllowed(permission: string): boolean {
        if (!this.session || !this.session.authorities) {
            return false;
        }
        for (var x = 0; x < this.session.authorities.length; x++) {
            if (permission == this.session.authorities[x].authority) {
                return true;
            }
        }
        return false
    };

    isLoggedIn() {
        return this.session != null;
    };

    getUserSession() {
        return this.session;
    }

    getSubject() {
        return this.subject;
    }

    setTargetUrl(url: string) {
        this.targetUrl = url;
    }

    getTargetUrl(url: string) {
        return this.targetUrl;
    }

    getCleanCompanySubject(): Subject<boolean> {
        return this.cleanCompanySubject;
    }

    getCompanyToRepresentSubject(): Subject<boolean> {
        return this.companyToRepresent;
    }

    getUserLogged() {
        return this.userLogged;
    }
}

class UserInitializationError extends Error {

    constructor(message?: string, private originalError?: Error) {
        super(message);
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/core/session.service.ts